import { render } from "./SearchSuggestions.vue?vue&type=template&id=36484026"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"

import "./SearchSuggestions.vue?vue&type=style&index=0&id=36484026&lang=css"
script.render = render

export default script